export default __webpack_public_path__ + "static/media/Main Slide2.fc2c2553.jpg";